import React from "react";
import { List as L } from "@planzone/dto";

import { Props } from "./types";
import { List } from "./list";

function countElement({ tasks, milestones, events }: L): number {
  return tasks.length + milestones.length + events.length;
}

function ListsList(props: Props) {
  return (
    <List
      list={{ ...props.list, elementsNumber: countElement(props.list) }}
      isOpen
    />
  );
}

export { ListsList };
